<section class="void-lease-agreement">
  <div class="header">
    <h1>{{ 'VOID_LEASE_AGREEMENT_FORM.HEADER' | translate }}</h1>
  </div>

  <form class="void-lease-agreement__form astral-content-width astral-stack-l" [formGroup]="form">
    <section class="astral-section-surface astral-stack-m">
      <p class="void-lease-agreement__lease-number">
        {{ 'LEASE_AGREEMENT.LEASE_AGREEMENT_NUMBER' | translate }}: {{ leaseAgreementNumber }}
      </p>

      <app-information-block [text]="'VOID_LEASE_AGREEMENT_FORM.HELP_TEXT.FUNCTION_DESCRIPTION'"></app-information-block>

      <astral-textarea [control]="form.controls['voidDescription']" [helpText]="'VOID_LEASE_AGREEMENT_FORM.HELP_TEXT.NOTE'"></astral-textarea>
    </section>

    @if (displayCreditInvoices) {
      <section class="astral-section-surface astral-stack-m">
        <h5 class="void-lease-agreement__section-title">{{ 'VOID_LEASE_AGREEMENT_FORM.CREDIT_INVOICES' | translate }}</h5>
        <app-multiselect-list-view
          [itemsSource]="invoices"
          [columnDefinition]="invoicesColumnDefinitions"
          [selectAll]="true"
          [preferencesKey]="'rent.void-lease-agreement.invoices'"
          >
        </app-multiselect-list-view>
      </section>
    }

    <div class="void-lease-agreement__actions">
      <astral-button
        variant="primary"
        type="button"
        labelKey="SAVE_BTN"
        [disabled]="invoices === undefined || saving"
        (click)="save()"
      ></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </form>
</section>
